export default {
      id: "onesite-o-dark-usage",
      viewBox: "0 0 121 120",
      url: __webpack_public_path__ + "sprite.svg#onesite-o-dark",
      toString: function () {
        return this.url;
      }
    }